module.exports = __webpack_public_path__ + "img/download-3.61b535bc.png";